import React, { useEffect, useState } from "react";
import axios from "axios";

const SERVER_URL = "https://allinone-clone-7d5d795e98ce.herokuapp.com";

const CTASection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${SERVER_URL}/api/cta-section`);
        if (res.data.success) {
          setData(res.data.data);
        }
      } catch (err) {
        console.error("Failed to load CTA section:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return null;
  if (!data || !data.isActive) return null;

  return (
    <>
      <section className="cta-section position-relative py-5 overflow-hidden" style={{ backgroundColor: "#050505" }}>
        
        {/* Deep Background Gradients */}
        <div className="position-absolute top-50 start-50 translate-middle w-100 h-100 z-n1 pointer-events-none">
            <div className="ambient-glow bg-primary opacity-20" style={{ width: "70vw", height: "70vh", filter: "blur(140px)", borderRadius: "50%", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}></div>
            <div className="grid-overlay position-absolute w-100 h-100" style={{ backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px)", backgroundSize: "40px 40px", maskImage: "radial-gradient(ellipse at center, black 40%, transparent 80%)", WebkitMaskImage: "radial-gradient(ellipse at center, black 40%, transparent 80%)" }}></div>
        </div>

        <div className="container mt-5 mb-5 position-relative z-1">
          <div className="cta-premium-wrapper rounded-5 p-4 p-md-5 position-relative overflow-hidden group">
            
            {/* Animated Edge Border */}
            <div className="cta-animated-border"></div>

            {/* Inner Content Wrapper */}
            <div className="cta-inner-content position-relative z-1 h-100 p-4 p-lg-5 rounded-5 d-flex flex-column justify-content-center" style={{ background: "rgba(12, 12, 18, 0.65)", backdropFilter: "blur(40px)", border: "1px solid rgba(255,255,255,0.05)" }}>
              
              {/* Subtle top inner glow */}
              <div className="position-absolute top-0 start-50 translate-middle-x w-75 h-25" style={{ background: "radial-gradient(ellipse at top, rgba(99, 102, 241, 0.15) 0%, transparent 70%)", pointerEvents: "none" }}></div>

              <div className="row g-5 align-items-center position-relative z-2">
                
                {/* Content Column */}
                <div className="col-lg-6 order-2 order-lg-1">
                  <div className="cta-content ps-lg-3 text-center text-lg-start">
                    
                    <span className="badge rounded-pill px-4 py-2 mb-4 d-inline-flex align-items-center shadow-sm" style={{ background: "rgba(16, 185, 129, 0.1)", border: "1px solid rgba(16, 185, 129, 0.2)", color: "#34d399", letterSpacing: "0.05em", fontWeight: "600" }}>
                      <i className="fa-solid fa-rocket me-2"></i> Instant Setup
                    </span>

                    <h2 className="display-4 fw-bold text-white mb-4 tracking-tight" style={{ lineHeight: "1.15" }}>
                      {data.title}
                    </h2>
                    
                    <p className="lead mb-5 opacity-75 text-white" style={{ fontSize: "1.15rem", lineHeight: "1.8", fontWeight: "300" }}>
                      {data.description}
                    </p>
                    
                    <div className="cta-button-wrapper d-flex flex-wrap gap-3 justify-content-center justify-content-lg-start">
                      <a href={data.button?.link} className="premium-btn position-relative d-inline-flex align-items-center justify-content-center px-5 py-3 rounded-pill text-white fw-bold text-decoration-none overflow-hidden">
                        <span className="position-relative z-1 d-flex align-items-center">
                          {data.button?.text} <i className="fa-solid fa-arrow-right-long ms-2"></i>
                        </span>
                        <div className="btn-glow-bg position-absolute w-100 h-100 top-0 start-0 z-0"></div>
                        <div className="btn-light-sweep position-absolute top-0 start-0 h-100 z-0"></div>
                      </a>
                    </div>
                    
                    <div className="mt-4 d-flex align-items-center justify-content-center justify-content-lg-start gap-2 text-white-50 small">
                        <i className="fa-solid fa-check text-success"></i> No credit card required. Cancel anytime.
                    </div>
                  </div>
                </div>

                {/* Image Column */}
                <div className="col-lg-6 order-1 order-lg-2">
                  <div className="cta-image-wrapper position-relative text-center d-flex justify-content-center align-items-center">
                    
                    {/* Glowing Orb Behind Images */}
                    <div className="position-absolute top-50 start-50 translate-middle bg-primary opacity-30 rounded-circle z-n1" style={{ width: "300px", height: "300px", filter: "blur(80px)" }}></div>

                    <div className="main-image d-inline-block rounded-4 overflow-hidden position-relative z-1 float-hover" style={{ boxShadow: "0 30px 60px rgba(0,0,0,0.6), 0 0 40px rgba(99, 102, 241, 0.2)", border: "1px solid rgba(255,255,255,0.1)" }}>
                      <img
                        src={data.images?.main}
                        alt="cta-main"
                        className="img-fluid"
                        style={{ maxHeight: "380px", objectFit: "cover" }}
                      />
                    </div>

                    {data.images?.secondary && (
                      <div className="secondary-image position-absolute bottom-0 end-0 translate-middle-x z-2 p-2 rounded-4 float-hover-alt d-none d-md-block" style={{ width: "200px", background: "rgba(20,20,25,0.8)", backdropFilter: "blur(20px)", border: "1px solid rgba(255,255,255,0.1)", boxShadow: "0 20px 40px rgba(0,0,0,0.5), 0 0 30px rgba(139, 92, 246, 0.3)", marginRight: "-10%" }}>
                        <img
                          src={data.images?.secondary}
                          alt="cta-secondary"
                          className="img-fluid rounded-3"
                        />
                      </div>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .tracking-tight {
            letter-spacing: -0.04em;
          }

          /* CTA Wrapper Animated Border */
          .cta-premium-wrapper {
             padding: 2px !important;
          }
          
          .cta-animated-border {
            position: absolute;
            top: -50%; left: -50%; width: 200%; height: 200%;
            background: conic-gradient(transparent, transparent, transparent, #6366f1, #8b5cf6, transparent);
            animation: rotate-border 6s linear infinite;
            z-index: 0;
            opacity: 0.5;
          }

          @keyframes rotate-border {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          /* Floating Animations for Images */
          .float-hover {
            animation: float 6s ease-in-out infinite;
            transition: transform 0.3s ease;
          }
          .float-hover-alt {
            animation: float-alt 7s ease-in-out infinite;
            transition: transform 0.3s ease;
          }

          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-15px); }
            100% { transform: translateY(0px); }
          }
          @keyframes float-alt {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
            100% { transform: translateY(0px); }
          }

          /* Premium Glowing Button */
          .premium-btn {
            background: rgba(255,255,255,0.03);
            border: 1px solid rgba(255,255,255,0.1);
            box-shadow: 0 10px 30px rgba(99, 102, 241, 0.2);
            transition: all 0.3s ease;
          }
          
          .premium-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 15px 40px rgba(99, 102, 241, 0.4), 0 0 20px rgba(139, 92, 246, 0.4);
            border-color: rgba(255,255,255,0.3);
          }

          .btn-glow-bg {
            background: linear-gradient(135deg, #6366f1, #8b5cf6);
            opacity: 0.9;
            transition: opacity 0.3s ease;
          }

          .premium-btn:hover .btn-glow-bg {
            opacity: 1;
          }

          .btn-light-sweep {
            width: 50px;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
            transform: skewX(-20deg) translateX(-150px);
            animation: sweep 4s infinite;
          }

          @keyframes sweep {
            0% { transform: skewX(-20deg) translateX(-150px); }
            20% { transform: skewX(-20deg) translateX(300px); }
            100% { transform: skewX(-20deg) translateX(300px); }
          }
        `}</style>
      </section>
    </>
  );
};

export default CTASection;
